module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/people-b208135e33c2bf6ab0589d5656e805b6.png";